import { Injectable } from '@angular/core';
import { Message } from 'primeng';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MenuService {
  public msgs: Message[] = [];
  public selectedMenu: string;

  public reloadMenu: BehaviorSubject<boolean> = new BehaviorSubject(null);

  getselectedMenu(): string {
    return this.selectedMenu;
  }

  setselectedMenu(itemLabel) {
    this.selectedMenu = itemLabel;
  }

  getTestString(): string {
    return 'Test string';
  }

  ShowSuccess(summary, message) {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: summary, detail: message });
  }

  ShowError(summary, message, lifeInSeconds?: number) {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: summary, detail: message });

    //alexP: commented, cause setTimeout doesn't seem to work well. the message is often hidden spontaneously
    //independend from what is set in setTimeout's delay

    ////lifeInSeconds == 0 is a case to make the message sticky
    //if (lifeInSeconds == null || lifeInSeconds > 0) {
    //    var $this = this;
    //    setTimeout(function () { $this.msgs = [] }, (lifeInSeconds == null ? this.defaultLife : lifeInSeconds) * 1000);
    //}
  }

  ShowWarning(summary, message) {
    this.msgs = [];
    this.msgs.push({ severity: 'warn', summary: summary, detail: message });
  }

  ShowInfo(summary, message) {
    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: summary, detail: message });
  }
}
